import { MutationHookOptions, gql } from '@apollo/client';

import { edeApplicationQuery } from 'routes/marketplace-ede/queries/ede/getEdeApplication';
import { useEdeMutation, useEdeQueryName } from 'routes/marketplace-ede/context/edeQueryProvider';

const queryType = 'ADD_MEMBER';

const useAddMemberMutation = (options: MutationHookOptions = {}) => {
  const queryName = useEdeQueryName(queryType);

  const ADD_MEMBER_MUTATION = gql`
    mutation AddMember($appID: ID!, $productAppId: ID!, $payload: [NewMemberInput!]!) {
      ${queryName} (appID: $appID, productAppId: $productAppId, payload: $payload) {
        ${edeApplicationQuery}
      }
    }
  `;

  return useEdeMutation(ADD_MEMBER_MUTATION, options);
};

export default useAddMemberMutation;
